module.exports = __webpack_public_path__ + "static/2-15d9daa800e247b7197ed339e554f3b8.png";